import React from 'react';
import '../styles/common/Modal.css';
import Modal from './common/Modal';

const AboutModal = ({ isOpen, onClose, locale = 'en' }) => (
  <Modal
    isOpen={isOpen}
    onClose={onClose}
    contentClassName="about-modal modal-content--modern"
    contentProps={{
      role: 'dialog',
      'aria-modal': 'true',
      'aria-labelledby': 'about-title',
      tabIndex: -1,
      onKeyDown: (e) => {
        if (e.key === 'Escape') onClose?.();
      },
    }}
  >
    <div className="modal-header">
      <h2 id="about-title" className="modal-title">
        {locale === 'ja' ? 'Chord Analyzerについて' : 'About Chord Analyzer'}
      </h2>
      <p className="modal-subtitle">Chord Analyzer</p>
    </div>

    <div className="modal-body about-modal-body">
      <div className="about-section">
        <div className="modal-field-label">{locale === 'ja' ? '音源クレジット' : 'Audio Credits'}</div>
        <div className="about-text">
          Salamander Grand Piano v3 by Alexander Holm
        </div>
        <div className="about-text">
          Remapped by kinwie (sfzinstruments/SalamanderGrandPiano)
        </div>
        <div className="about-text">
          {locale === 'ja' ? 'ライセンス: CC BY 3.0' : 'Licensed under CC BY 3.0'}
        </div>
      </div>
    </div>

    <div className="modal-footer modal-buttons">
      <button className="cancel" onClick={onClose}>
        {locale === 'ja' ? '閉じる' : 'Close'}
      </button>
    </div>
  </Modal>
);

export default AboutModal;
